/** Keep C1 shell behaviour away from creation and nested application workspaces. */
export function isApplicationDetailsRoute(pathname: string): boolean {
  const match = /^\/applications\/([^/]+)\/?$/i.exec(pathname);
  if (!match) return false;
  let segment: string;
  try { segment = decodeURIComponent(match[1]); } catch { return false; }
  return !['new', 'terms'].includes(segment.toLowerCase()) && !segment.includes('/');
}
